export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'BE',
  'merchantReturnLink': 'https://www.timberland.be/fr-be/aide-et-contact/retours',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
